import styled from 'styled-components';

export const UserImage = styled.img`
  display: inline-block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  vertical-align: middle;
`;
